/**
 * Favourites and last played games kept in this browser, shown while logged
 * out. Logged-in players read the player games API, and every list it returns
 * is copied here so it stays visible after logout.
 */
export const GUEST_FAV_GAMES_KEY = "guestFavGames";
export const GUEST_LAST_PLAYED_KEY = "guestLastPlayedGames";
const LAST_PLAYED_LIMIT = 20;

function read(key) {
  try {
    const list = JSON.parse(localStorage.getItem(key));
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
}

function write(key, list) {
  try {
    localStorage.setItem(key, JSON.stringify(list));
  } catch {
    // localStorage may be unavailable or full
  }
}

export const saveGuestFavGames = (list) => write(GUEST_FAV_GAMES_KEY, list);
export const saveGuestLastPlayedGames = (list) =>
  write(GUEST_LAST_PLAYED_KEY, list);

const sameGame = (a, b) => String(a.id) === String(b.id);

export const getGuestFavGames = () => read(GUEST_FAV_GAMES_KEY);
export const getGuestLastPlayedGames = () => read(GUEST_LAST_PLAYED_KEY);

/** Adds or removes the game; returns both lists with is_favorite in sync. */
export function toggleGuestFavourite(game) {
  const favs = getGuestFavGames();
  const isFavorite = !favs.some((g) => sameGame(g, game));
  const others = favs.filter((g) => !sameGame(g, game));
  const favGames = isFavorite
    ? [{ ...game, is_favorite: true }, ...others]
    : others;
  const lastPlayedGames = getGuestLastPlayedGames().map((g) =>
    sameGame(g, game) ? { ...g, is_favorite: isFavorite } : g
  );
  write(GUEST_FAV_GAMES_KEY, favGames);
  write(GUEST_LAST_PLAYED_KEY, lastPlayedGames);
  return { favGames, lastPlayedGames, isFavorite };
}

/** Moves the game to the front of last played; returns the new list. */
export function recordGuestLastPlayed(game) {
  const isFavorite = getGuestFavGames().some((g) => sameGame(g, game));
  const lastPlayedGames = [
    { ...game, is_favorite: isFavorite },
    ...getGuestLastPlayedGames().filter((g) => !sameGame(g, game)),
  ].slice(0, LAST_PLAYED_LIMIT);
  write(GUEST_LAST_PLAYED_KEY, lastPlayedGames);
  return lastPlayedGames;
}
